import type { ParsedUrlQuery } from "node:querystring";
import { format } from "date-fns";

import { DateRange } from "@zapier/design-system";

export const dateFormat = "yyyy-MM-dd";

function hasTimestamp(date: string | undefined) {
  return Boolean(date?.includes("T"));
}

export function getQueryFromDateRange(
  date: DateRange,
  currentQueryParams: ParsedUrlQuery
) {
  const shouldUseTimestamp =
    hasTimestamp(currentQueryParams?.start_datetime as string | undefined) ||
    hasTimestamp(currentQueryParams?.end_datetime as string | undefined);

  return {
    end_datetime: date?.to
      ? shouldUseTimestamp
        ? date.to.toISOString()
        : format(date.to, dateFormat)
      : undefined,
    start_datetime: date?.from
      ? shouldUseTimestamp
        ? date.from.toISOString()
        : format(date.from, dateFormat)
      : undefined,
  };
}
